module.exports = __webpack_public_path__ + "static/media/tip_dog_chewable.0204eb8e.png";